<template>
  <h2 class="title-blue">
    <span>{{ title }}</span>
    <span class="ms-3">({{ t("N_RESULTS", {count: numberOfResults}) }})</span>
  </h2>
</template>

<script setup lang="ts">
import {useI18n} from "vue-i18n";

const {t} = useI18n();

const props = defineProps<{
  title: string;
  numberOfResults: number;
}>();
</script>

<style scoped lang="scss">
.title-blue {
  text-transform: unset;

  & > span:last-child {
    font-size: 0.6em;
    display: inline-block;
    vertical-align: middle;
  }
}
</style>
